import { render, staticRenderFns } from "./WideAccount.vue?vue&type=template&id=7d669a2e&scoped=true&"
import script from "./WideAccount.vue?vue&type=script&lang=js&"
export * from "./WideAccount.vue?vue&type=script&lang=js&"
import style0 from "./WideAccount.vue?vue&type=style&index=0&id=7d669a2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d669a2e",
  null
  
)

export default component.exports